import React from "react";

import FlyDuration from "../../components/filters/FlyDurationV2";
import SortBy from "../filters/SortByV2";
import PriceRange from "../../components/filters/PriceRangeV2";
import DepartureTimeRange from "../../components/filters/TimeRangeV2";
import ArrivalTimeRange from "../../components/filters/TimeRangeV2";
import Baggages from "../../components/filters/Baggages";
import MaxStops from "../../components/filters/MaxStopsV2";
import { useSelector } from "react-redux";
import IncrementDecrement from "../filters/IncrementDecrement";
import { FormControl, FormLabel } from "@mui/material";
import "./flightFilters.css";

const JOURNEY_TYPES = ["One Way", "Return"];
const PRICE_RANGES = {
  USD: [0, 5000],
  AUD: [0, 10000],
  INR: [0, 100000],
};

export default function FlightFilter(props) {
  const {
    useSortBy,
    setSortBy,
    sortBy,
    handleSortByChange,
    useflyDuration,
    setUseFlyDuration,
    flyDuration,
    handleFlyDurationChange,
    usePriceRange,
    setUsePriceRange,
    priceRange,
    handlePriceChange,
    useStops,
    setUseStops,
    stops,
    handleMaxStopsChange,
    useDepartureTimeRange,
    setUseDepartureTimeRange,
    departureTimeRange,
    handleDepartureTimeChange,
    useArrivalTimeRange,
    setUseArrivalTimeRange,
    arrivalTimeRange,
    handleArrivalTimeChange,
    useBaggage,
    setUseBaggage,
    baggage,
    handleBaggageChange,
    minMaxPrice,
    setShowFilters,
    showFilters,
  } = props;

  const currency = useSelector((state) => state.flight.currency);

  return (
    <div
      className={`filter-container col-md-2 ${
        showFilters ? "active-filter" : ""
      }`}
    >
      <div className="filter-box">
        <SortBy
          used={useSortBy}
          onReset={() => setSortBy("price")}
          defaultValue={1}
          value={sortBy}
          onChange={handleSortByChange}
        />
      </div>
      <div className="filter-box">
        <FlyDuration
          used={useflyDuration}
          onReset={() => setUseFlyDuration(false)}
          defaultValue={1}
          value={flyDuration}
          onChange={handleFlyDurationChange}
        />
      </div>
      <div className="filter-box">
        <PriceRange
          used={usePriceRange}
          onReset={() => setUsePriceRange(false)}
          minValue={minMaxPrice ? minMaxPrice.min : PRICE_RANGES[currency][0]}
          maxValue={minMaxPrice ? minMaxPrice.max : PRICE_RANGES[currency][1]}
          defaultValue={
            PRICE_RANGES[currency] ? PRICE_RANGES[currency] : [0, 1000]
          }
          value={priceRange}
          onChange={handlePriceChange}
        />
      </div>
      <div className="filter-box">
        <MaxStops
          used={useStops}
          onReset={() => setUseStops(false)}
          value={stops}
          onChange={handleMaxStopsChange}
        />
      </div>
      {/* <div className="filter-box">
        <DepartureTimeRange
          used={useDepartureTimeRange}
          onReset={() => setUseDepartureTimeRange(false)}
          value={departureTimeRange}
          label="Departure Time"
          onChange={handleDepartureTimeChange}
        />
      </div>
      <div className="filter-box">
        <ArrivalTimeRange
          used={useArrivalTimeRange}
          onReset={() => setUseArrivalTimeRange(false)}
          value={arrivalTimeRange}
          label="Arrival Time"
          onChange={handleArrivalTimeChange}
        />
      </div> */}

      <div className="filter-box">
        <FormControl
          sx={{
            "&.MuiFormControl-root": {
              display: "block",
            },
            padding: "0 1rem",
          }}
        >
          <FormLabel
            id="stops-check-boxes-group"
            sx={{
              display: "block",
              fontWeight: "700",
              textAlign: "start",
              color: "#000000",
            }}
          >
            Baggage
          </FormLabel>
          <div>
            <IncrementDecrement
              label="Cabin Baggage"
              onChange={handleBaggageChange}
              type="cabin"
              defaultCount={baggage.hand_bag}
            />
            <IncrementDecrement
              label="Checked Baggage"
              onChange={handleBaggageChange}
              type="checked"
              defaultCount={baggage.hold_bag}
            />
          </div>
        </FormControl>
      </div>
    </div>
  );
}
